import { useEffect, useState } from "react";

import { LoadingSpinner, Table, TablePagination } from "@newsela/angelou";
import Image from "next/image";
import PropTypes from "prop-types";

import challengeMonthIcon from "../../../../public/images/icons/challenge-monthly-icon.svg";
import {
  contentWrapper,
  headerCss,
  tableWrapper,
  tableStructureCss,
  wrapperCss,
  pageSelectCss,
  paginationCss,
  studentRowTokensWrapper,
  studentRowTokens,
  noDataAvailableCss,
} from "./ChallengesTeacherStudentData.style";

const propTypes = {
  data: PropTypes.any,
};

const ChallengesTeacherStudentData = ({ data }) => {
  const [students, setStudents] = useState([]);
  // const renderProgressbar = (progressData) => {
  //   return (
  //     <div css={percentageWrapperCss}>
  //       <p css={percentageTextCss}>{progressData}%</p>
  //       <div css={progressBarContentCss}>
  //         <div css={progressPercentageCss(progressData, 100)} />
  //       </div>
  //     </div>
  //   );
  // };

  const renderGrade = (grade) => {
    const lastChar = grade > 20 ? grade.substr(grade.length - 1) : grade;
    switch (lastChar) {
      case "1":
        return `${grade}st`;
      case "2":
        return `${grade}nd`;
      case "3":
        return `${grade}rd`;
      default:
        return `${grade}th`;
    }
  };

  const renderTokens = (tokens) => {
    return (
      <div css={studentRowTokensWrapper}>
        <Image src={challengeMonthIcon} width={16} height={16} />
        <p css={studentRowTokens}>{tokens}</p>
      </div>
    );
  };

  const generateStudentData = (studentList) => {
    const newList = studentList?.map((student) => {
      return {
        student: student.name,
        tokens: renderTokens(student.earned_tokens),
        articles: student.articles,
        grade: renderGrade(String(student.grade)),
        class: student.classroom,
        // avgQuizScore: renderProgressbar(student.activity_report.quiz.score_average),
        // avgPowerWordsScore: renderProgressbar(student.activity_report.power_words.score_average)
      };
    });
    setStudents(newList);
  };

  useEffect(() => {
    generateStudentData(data?.students);
  }, [data]);

  const [page, setPage] = useState(0);
  const pageSize = 10;
  const [filteredData, setFilteredData] = useState(students);

  useEffect(() => {
    if (students?.length > 0) {
      setFilteredData(
        students?.slice(
          page > 0 ? page * pageSize : 0,
          (page > 0 ? page * pageSize : 0) + pageSize,
        ),
      );
    } else {
      setFilteredData([]);
    }
  }, [students]);

  const changePage = (value) => {
    const newPage = page + value;
    setPage(newPage);
    setFilteredData(
      students?.slice(
        newPage > 0 ? newPage * pageSize : 0,
        (newPage > 0 ? newPage * pageSize : 0) + pageSize,
      ),
    );
  };

  const goToFirstPage = () => {
    const newPage = 0;
    setPage(newPage);
    setFilteredData(
      students?.slice(
        newPage > 0 ? newPage * pageSize : 0,
        (newPage > 0 ? newPage * pageSize : 0) + pageSize,
      ),
    );
  };

  return (
    <div css={contentWrapper}>
      {!data ? (
        <LoadingSpinner />
      ) : data === "no data" ? (
        <div css={noDataAvailableCss}>No data available.</div>
      ) : (
        <>
          <h4 css={headerCss}>Student data</h4>
          <Table
            __cssFor={{
              root: tableWrapper,
              tableContainer: tableWrapper,
              scrollContainer: wrapperCss,
              TableControlPanel: { root: pageSelectCss },
              table: tableStructureCss,
            }}
            columns={[
              {
                accessor: "student",
                Header: "Student",
                fixed: true,
              },
              {
                accessor: "tokens",
                Header: "Tokens",
              },
              {
                accessor: "articles",
                Header: "Articles",
              },
              {
                accessor: "grade",
                Header: "Grade",
              },
              {
                accessor: "class",
                Header: "Class",
              },
              /*
                  The Avg. score for activities will be temporarily removed
                  from Teacher Insights until we have successfully integrated
                  with Nightingale as we've been facing many performance issues
                  with the reporting API.
                  */
              // {
              //   accessor: 'avgQuizScore',
              //   Header: 'Avg. quiz score',
              // },
              // {
              //   accessor: 'avgPowerWordsScore',
              //   Header: 'Avg. Power Words score',
              // },
            ]}
            data={filteredData}
          />
          <TablePagination
            pageSize={pageSize}
            pageIndex={page}
            totalItems={students?.length}
            canNextPage={(page + 1) * pageSize < students?.length}
            canPreviousPage={page > 0}
            nextPage={() => changePage(1)}
            previousPage={() => changePage(-1)}
            gotoPage={goToFirstPage}
            __cssFor={{
              root: paginationCss,
              PaginationSelect: { root: pageSelectCss },
              // PaginationNavigation:
            }}
          />
        </>
      )}
    </div>
  );
};

ChallengesTeacherStudentData.propTypes = propTypes;

export default ChallengesTeacherStudentData;
